import React from 'react';
import {useAppSelector} from '../../../../redux';
import {useIsDesktop} from '../../../../shared/hooks/useIsDesktop';
import ViewDesktop from './viewDesktop';
import ViewMobile from './viewMobile';

export const AllNews = () => {
  const news = useAppSelector((state) => state.news);

  const isDesktop = useIsDesktop();
  const View = isDesktop ? ViewDesktop : ViewMobile;
  return <View news={news} newsNotFound={Boolean(!news.isLoading && !news.selection.length && news.latest)} />;
};
